import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import React__default, { useRef, useState } from 'react';
import { keyframes, jsx } from '@emotion/react';
import { COLORS } from '../../styles/colors.js';
import Portal from '../Portal/Portal.js';

var _templateObject;
function Tooltip(_ref) {
  var message = _ref.message,
    children = _ref.children;
  var trigger = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState({
      x: 0,
      y: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    offsets = _useState4[0],
    setOffsets = _useState4[1];
  function getOffsets(rect) {
    var x = rect.x,
      y = rect.y,
      width = rect.width,
      height = rect.height;
    return {
      x: x + width + 15,
      y: y + height / 2
    };
  }
  function show() {
    setVisible(true);
    if (!trigger.current) {
      return;
    }
    setOffsets(getOffsets(trigger.current.getBoundingClientRect()));
  }
  function hide() {
    setVisible(false);
  }
  return jsx(React__default.Fragment, null, jsx("div", {
    ref: trigger,
    style: {
      display: 'inline-block'
    },
    onFocus: show,
    onBlur: hide,
    onMouseEnter: show,
    onMouseLeave: hide
  }, children), isVisible && jsx(Portal, null, jsx(Message, offsets, message)));
}
var show = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translate3d(-5px, -50%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, -50%, 0);\n  }\n"])));
var Message = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1k6o45b0"
} : {
  target: "e1k6o45b0",
  label: "Message"
})("position:fixed;top:", function (_ref2) {
  var y = _ref2.y;
  return y;
}, "px;left:", function (_ref3) {
  var x = _ref3.x;
  return x;
}, "px;max-width:200px;padding:4px 6px;color:", COLORS.gray0, ";font-size:11px;font-weight:500;border-radius:3px;background:", COLORS.slategray90, ";transform:translateY(-50%);pointer-events:none;animation:", show, " 0.3s ease-in-out;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
